import { DisabledPrompt, useStateManager } from "@bcm-dev/bcms-vite";
import { TableBody, TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableView } from "components/shared";
import { PrimaryButton, SecondaryButton } from "components/ui";
import { Account } from "model";
import "./styles.css";
import "./mobile.css";


/**
 * @function EDEDeliveryOptionsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for the tab content "EDEDeliveryOptionsPage".
 * @example
 * <EDEDeliveryOptionsPage />
 */
export default function EDEDeliveryOptionsPage(props) {
    return (
    <div className="ede-delivery-options-page">
        <PageContent { ...props } />
    </div>
    );
}

/**
 * @function PageContent
 * @return {React.Component}
 * @exported false
 * @description The content for the page.
 * @example
 * <PageContent />
 */
function PageContent(props) {
    const { data, ui, didUpdateAccounts, resetAccounts } = useStateManager();
    const accounts = data.accounts ?? Account.initAll();
    const subheader = `Change statement delivery options by account below.
    At least one account must be set to eStatement. Select only one delivery option per account.`;
    const deliveryOptions =  [ ...data.deliveryOptions ];

    const brandableColumns = deliveryOptions.reduce((acc, item) => {
        acc.push(
            <TableColumnView key={ item.index } className="account-number-column" text={ item.label } />
        );
        return acc;
    }, []);

    const rows = data.accounts.reduce((acc, item) => {
        acc.push(
            <AccountTableRow key={ item.id } account={ item }/>
        );
        return acc;
    }, []);

    return (
        <>
            <p className="subheader">{ subheader }</p>
            <TableView className="ede-others-statements-table">
                <TableColumnContainer>
                    <TableColumnView className="text-left date" text={ "Account Type" } />
                    <TableColumnView className="text-left description" text={ "Account Number" } />
                    { brandableColumns }
                </TableColumnContainer>
                <TableBody>
                    { rows }
                    <tr>
                        <td className="text-center table-item-view" colSpan={ 2 + deliveryOptions.length }></td>
                    </tr>
                    <tr>
                        <td className="text-center table-item-view" colSpan={ 2 + deliveryOptions.length }></td>
                    </tr>
                </TableBody>
                
            </TableView>
            <div className={ `button-container flex-container flex-horizontal` }>
                <div className="set-width primary-button-container">
                    <DisabledPrompt>
                        <PrimaryButton text="Change Delivery Options" className={ `${ didUpdateAccounts() ? "" : "disabled" }` } />
                    </DisabledPrompt>
                </div>
                <div className="set-width">
                    <SecondaryButton text="Cancel" onClick={ resetAccounts } className="set-width" />
                </div>
            </div>
        </>
    );
}

/**
 * @function AccountTableRow
 * @return {React.Component}
 * @exported false
 * @description A row in the table in the page.
 * @example
 * <AccountTableRow />
 */
function AccountTableRow(props) {
    const { data, ui, onUpdate, onCancel, onDeliveryOptionChange } = useStateManager();
    const account = props.account ?? Account.firstInstanceOf();
    const accountTypeMap = data.accountTypeMap;
    let options =  [ ...data.deliveryOptions ];

    const brandedColumns = options.reduce((acc, item) => {
        const input = <input id={ `account_${ account.id }` } 
        onChange={ onDeliveryOptionChange("statementPreference", account.id, item) } 
        name={ `account_delivery_option_${ account.id }` } 
        type="radio" 
        checked={ account.statementPreference === item.label }
        />;

        acc.push(
            <TableItemTextView key={ item.index } className="account-number-column"
             text={ input } />
        );
        return acc;
    }, []);

    return (
    <TableItemContainer>
        <TableItemTextView className="account-nickname-column" text={ accountTypeMap[account.type] } />
        <TableItemTextView className="account-number-column" text={ account.number } />
        { brandedColumns }
    </TableItemContainer>
    );
}